import { create } from 'zustand';

interface AuthState {
  accessToken: string | null;
  user: { id: string; email: string; role: string } | null;
  setSession: (token: string, user: AuthState['user']) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setSession: (accessToken, user) => set({ accessToken, user }),
  clearSession: () => set({ accessToken: null, user: null }),
}));
